import { render, staticRenderFns } from "./DocumentsManager.vue?vue&type=template&id=447207f6&"
import script from "./DocumentsManager.vue?vue&type=script&lang=js&"
export * from "./DocumentsManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports